import { FETCH_USER_CERTIFICATES, FETCH_INDIVIDUAL_CERTIFICATE, FETCH_USERS, FETCH_LEARNING_SESSION_DATA,USER_REGISTRATION, UPDATE_USER_STATUS ,ADD_USER, RESET_STATE, DELETE_USER, FETCH_INDIVIDUAL_USER, UPDATE_USER, UPLOAD_USERS_CSV } from "./actions.type";
import { SET_USER_CERTIFICATES, SET_USERS,SET_USER_STATUS ,SET_INDIVIDUAL_USER,SET_ERROR_USER, STATE_RESET, SET_LEARNING_SESSION_DATA} from "./mutations.type";
import { UsersService, LearningSessionService } from "@/common/api.service";

const initialState = () => {
    return {
    users: [],
    individualuser: [],
    response: null,
    usererrors: [],
    learningsessiondata:[],
    usercertificates:[]
    }
}

export const state = initialState()

const getters = {
    users(state) {
        return state.users
    },
    individualuser(state) {
        return state.individualuser
    },
    usercertificates(state) {
        return state.usercertificates
    },
    learningsessiondata(state) {
        return state.learningsessiondata
    }        
};


const actions = {
    async [FETCH_USERS](context,slug) {
        const { data } = await UsersService.get(slug)
        context.commit(SET_USERS, data.data)
        return data;
    },
    async [FETCH_LEARNING_SESSION_DATA](context){
        const { data } = await LearningSessionService.get()
        context.commit(SET_LEARNING_SESSION_DATA, data.data)
        return data;
    },
    [USER_REGISTRATION](context, payload) {
        return UsersService.create(payload, 'register')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message)
        });
    }, 

    [ADD_USER](context, payload) {
        return UsersService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message)
        });
    }, 
    [UPLOAD_USERS_CSV](context, payload) {
        return UsersService.uploadCSV(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.message)
        });
    },   
    [DELETE_USER] (context, userid) {
        return UsersService.delete(userid)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.errors)
        });
    },
    [UPDATE_USER](context, payload) {
        return UsersService.create(payload, payload.user_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message)
        });
    }, 
    async [FETCH_INDIVIDUAL_USER](context, payload) {
        const { data } = await UsersService.get(payload)
        context.commit(SET_INDIVIDUAL_USER, data.data)
        return data; 
    }, 
    async [UPDATE_USER_STATUS] (context, payload) {
        const { data } = await UsersService.create(payload, payload.user_id)
        context.commit(SET_USER_STATUS, data.data)
        return data;         
    },
    async [FETCH_USER_CERTIFICATES](context,slug) {
        const { data } = await UsersService.get(slug)
        context.commit(SET_USER_CERTIFICATES, data.data)
        return data;
    },
    [FETCH_INDIVIDUAL_CERTIFICATE](context, payload) {
        return UsersService.get(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_USER, error.response.data.hasOwnProperty('errors') ? error.response.data.errors : error.response.data.message)
        });
    }, 
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
    }      
};

const mutations = {
    [SET_ERROR_USER](state, error) {
        state.usererrors = error
    },    
    [SET_LEARNING_SESSION_DATA](state,sessiondata){
        state.learningsessiondata= sessiondata
    },
    [SET_USERS](state, users) {
        state.users = users
    },
    [SET_USER_CERTIFICATES](state, usercertificatesdata) {
        state.usercertificates = usercertificatesdata
    },
    [SET_INDIVIDUAL_USER](state, user) {
        state.individualuser = user
    },  
    [SET_USER_STATUS] (state,user){
        let id = state.users.findIndex(x => x.user_id === user.user_id)
        state.users[id] = user
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }     
};

export default {
    state,
    getters,
    actions,
    mutations
};